import React from 'react';
import PropTypes from 'prop-types';
import styles from './placeholdersStyles';

class Placeholders extends React.PureComponent {
  render() {
    const { amount } = this.props;

    return (
      <div>
        {[...Array(amount)].map((_, index) => (
          <div className={`placeholder p${index % 2}`} key={`placeholder.${index * 2}`}>
            <span className="s1" />
            <span className="s2" />
            <span className="s3" />
            <span className="img" />
            <span className="cover" />
          </div>
        ))}
        <style jsx>{styles}</style>
      </div>
    );
  }
}

Placeholders.defaultProps = {
  amount: 10,
};

Placeholders.propTypes = {
  amount: PropTypes.number,
};

export default Placeholders;



// WEBPACK FOOTER //
// ./app/common/Placeholders/Placeholders.js